var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcMilestone2Off = function SvgIcMilestone2Off(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8DF",
    d: "M17.042 15.134c-.206 0-.412-.042-.577-.165a2 2 0 0 1-.494-.37l-2.142-2.348a1 1 0 0 1-.123-.206c-.041-.083-.041-.165-.041-.248s.04-.164.04-.247c.042-.082.083-.123.124-.206l1.36-1.235a.6.6 0 0 1 .411-.165c.083 0 .165.041.248.041.082.042.123.083.205.124l1.36 1.483c.205-.124.453-.165.7-.165.288 0 .535.123.741.288s.37.37.494.66c.083.246.124.534.041.782a1.75 1.75 0 0 1-.412.7l-.823.741c-.165.124-.33.247-.536.33a.83.83 0 0 1-.576.205"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A0A2AE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.987,
    d: "M17.042 15.134c-.206 0-.412-.042-.577-.165a2 2 0 0 1-.494-.37l-2.142-2.348a1 1 0 0 1-.123-.206c-.041-.083-.041-.165-.041-.248s.04-.164.04-.247c.042-.082.083-.123.124-.206l1.36-1.235a.6.6 0 0 1 .411-.165c.083 0 .165.041.248.041.082.042.123.083.205.124l1.36 1.483c.205-.124.453-.165.7-.165.288 0 .535.123.741.288s.37.37.494.66c.083.246.124.534.041.782a1.75 1.75 0 0 1-.412.7l-.823.741c-.165.124-.33.247-.536.33a.83.83 0 0 1-.576.205"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8DF",
    d: "M13.131.924a6.14 6.14 0 0 0-3.583.906c-1.07.66-1.935 1.606-2.43 2.76a2.35 2.35 0 0 0-1.482.658 2.33 2.33 0 0 0-.66 1.483c-.04.577.166 1.112.495 1.565.37.453.865.741 1.4.824a6.3 6.3 0 0 0 1.854 2.76 5.94 5.94 0 0 0 3.047 1.4 6.6 6.6 0 0 0 3.336-.371 6.2 6.2 0 0 0 2.677-2.018 6.14 6.14 0 0 0 1.236-3.09c.123-1.111-.082-2.264-.536-3.294a6.54 6.54 0 0 0-2.182-2.553c-.948-.618-2.018-.948-3.172-1.03"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A0A2AE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.987,
    d: "M13.131.924a6.14 6.14 0 0 0-3.583.906c-1.07.66-1.935 1.606-2.43 2.76a2.35 2.35 0 0 0-1.482.658 2.33 2.33 0 0 0-.66 1.483c-.04.577.166 1.112.495 1.565.37.453.865.741 1.4.824a6.3 6.3 0 0 0 1.854 2.76 5.94 5.94 0 0 0 3.047 1.4 6.6 6.6 0 0 0 3.336-.371 6.2 6.2 0 0 0 2.677-2.018 6.14 6.14 0 0 0 1.236-3.09c.123-1.111-.082-2.264-.536-3.294a6.54 6.54 0 0 0-2.182-2.553c-.948-.618-2.018-.948-3.172-1.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0A2AE",
    stroke: "#A0A2AE",
    strokeWidth: 0.527,
    d: "M13.83 6.32c.205 0 .411-.164.411-.37s-.164-.412-.37-.412-.412.165-.412.371.165.412.37.412ZM16.217 6.444c.206 0 .412-.165.412-.37 0-.207-.165-.413-.371-.413s-.412.165-.412.37c0 .207.165.413.37.413Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8FA",
    d: "M16.096 18.182a.8.8 0 0 1-.289-.082.5.5 0 0 1-.206-.206l-1.812-3.377-4.613-.247a.8.8 0 0 1-.288-.082l-.741-.454c-.083-.04-.165-.164-.247-.247L5.882 9.04a.58.58 0 0 0-.247-.288.66.66 0 0 0-.371-.123l-1.277-.083c-.165 0-.288-.082-.412-.206a.6.6 0 0 1-.164-.412l.04-.906c0-.164.083-.288.207-.412a.6.6 0 0 1 .411-.164l1.318.082c.495.041.989.206 1.4.494.413.289.742.7.948 1.153l.824 1.813 5.107.247c.247 0 .535.082.782.206s.453.288.618.453c.165.206.33.412.412.659s.123.535.123.782l-.04 1.03 1.894 3.542c.082.123.082.288.04.453a.47.47 0 0 1-.288.33l-.782.411a.8.8 0 0 1-.33.082m-2.554-5.765v-.165l-3.995-.206.082.165z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A0A2AE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.987,
    d: "M16.096 18.182a.8.8 0 0 1-.289-.082.5.5 0 0 1-.206-.206l-1.812-3.377-4.613-.247a.8.8 0 0 1-.288-.082l-.741-.454c-.083-.04-.165-.164-.247-.247L5.882 9.04a.58.58 0 0 0-.247-.288.66.66 0 0 0-.371-.123l-1.277-.083c-.165 0-.288-.082-.412-.206a.6.6 0 0 1-.164-.412l.04-.906c0-.164.083-.288.207-.412a.6.6 0 0 1 .411-.164l1.318.082c.495.041.989.206 1.4.494.413.289.742.7.948 1.153l.824 1.813 5.107.247c.247 0 .535.082.782.206s.453.288.618.453c.165.206.33.412.412.659s.123.535.123.782l-.04 1.03 1.894 3.542c.082.123.082.288.04.453a.47.47 0 0 1-.288.33l-.782.411a.8.8 0 0 1-.33.082m-2.554-5.765v-.165l-3.995-.206.082.165z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.3 19.087c.988.04 1.853-.742 1.894-1.73s-.741-1.853-1.73-1.894c-.988-.042-1.853.74-1.894 1.73-.082.988.7 1.811 1.73 1.894"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0A2AE",
    d: "M16.351 17.8c.295 0 .547-.21.547-.504s-.21-.547-.505-.547c-.294 0-.547.21-.547.505 0 .294.21.547.505.547"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A0A2AE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.987,
    d: "M16.3 19.087c.988.04 1.853-.742 1.894-1.73s-.741-1.853-1.73-1.894c-.988-.042-1.853.74-1.894 1.73-.082.988.7 1.811 1.73 1.894"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8DF",
    d: "m10.781 9.532-1.359 1.235q-.247.247-.618.37a1.3 1.3 0 0 1-.7.083c-.247 0-.453-.082-.7-.165-.206-.082-.412-.247-.577-.412a1.55 1.55 0 0 1-.37-.617 1.3 1.3 0 0 1-.083-.7c0-.248.083-.453.165-.66.083-.205.247-.411.412-.576l.906-.824"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A0A2AE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.987,
    d: "m10.781 9.532-1.359 1.235q-.247.247-.618.37a1.3 1.3 0 0 1-.7.083c-.247 0-.453-.082-.7-.165-.206-.082-.412-.247-.577-.412a1.55 1.55 0 0 1-.37-.617 1.3 1.3 0 0 1-.083-.7c0-.248.083-.453.165-.66.083-.205.247-.411.412-.576l.906-.824"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBEB",
    d: "M7.898 11.468c-1.853-.082-3.46 1.36-3.541 3.213-.083 1.853 1.359 3.46 3.212 3.542s3.46-1.36 3.542-3.213c.123-1.853-1.318-3.46-3.213-3.542"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBEB",
    d: "M7.94 10.685a4.24 4.24 0 0 0-2.348.576c-.7.412-1.276 1.07-1.647 1.812-.37.742-.494 1.606-.37 2.389a4.3 4.3 0 0 0 1.029 2.183c.577.617 1.277 1.07 2.1 1.235a4.07 4.07 0 0 0 2.43-.123 4.22 4.22 0 0 0 1.936-1.442 4.12 4.12 0 0 0 .824-2.306 3.56 3.56 0 0 0-.247-1.606c-.206-.536-.453-.989-.824-1.4a4.4 4.4 0 0 0-1.318-.989 3.8 3.8 0 0 0-1.565-.33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#A0A2AE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.987,
    d: "M7.94 10.685a4.24 4.24 0 0 0-2.348.576c-.7.412-1.276 1.07-1.647 1.812-.37.742-.494 1.606-.37 2.389a4.3 4.3 0 0 0 1.029 2.183c.577.617 1.277 1.07 2.1 1.235a4.07 4.07 0 0 0 2.43-.123 4.22 4.22 0 0 0 1.936-1.442 4.12 4.12 0 0 0 .824-2.306 3.56 3.56 0 0 0-.247-1.606c-.206-.536-.453-.989-.824-1.4a4.4 4.4 0 0 0-1.318-.989 3.8 3.8 0 0 0-1.565-.33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A0A2AE",
    strokeWidth: 0.987,
    d: "m7.691 14.846.206-4.037M7.692 14.846 4.44 16.7M7.693 14.846l3.378 2.348"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0A2AE",
    d: "M7.692 16.122c.7.041 1.318-.494 1.318-1.194.041-.7-.494-1.318-1.194-1.318-.7-.041-1.318.494-1.318 1.194-.041.7.494 1.277 1.194 1.318"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A0A2AE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.987,
    d: "M7.692 16.122c.7.041 1.318-.494 1.318-1.194.041-.7-.494-1.318-1.194-1.318-.7-.041-1.318.494-1.318 1.194-.041.7.494 1.277 1.194 1.318"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8FA",
    d: "m3.246 5.99-1.771-.082c-.453-.041-.824.33-.865.783L.569 7.885c-.041.453.33.824.782.865l1.771.082c.453.041.824-.33.865-.782l.041-1.195c0-.453-.33-.864-.782-.864"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A0A2AE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.987,
    d: "m3.246 5.99-1.771-.082c-.453-.041-.824.33-.865.783L.569 7.885c-.041.453.33.824.782.865l1.771.082c.453.041.824-.33.865-.782l.041-1.195c0-.453-.33-.864-.782-.864"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIcMilestone2Off;